import React from 'react'

const Header = ({ year }) => {
	return (
		<header>
			<p className='e1'>Sant Jordi {year}</p>
		</header>
	)
}

export default Header
